export const rolesInitialState = {
  name: '',
  machineModels: [],
  operations: [],
  permissions: {
    dashboard: false,
    aimVision: false,
    hr: false,
    fuel: false,
    machinery: false,
    inventory: false,
    analytics: false,
    contractors: false,
    resources: false,
  },
  freeDays: [],
  permissionPolicy: null,
  workScheduleModelId: null,
  shifts: [],
  shiftChangeType: null,
  shiftChangeInterval: 0,
  vacationDays: 0,
  logisticsInfo: {
    hasFoodProvided: false,
    hasFoodAllowance: false,
    foodAllowanceInCompanyAmount: 0,
    foodAllowanceOutCompanyAmount: 0,
    hasAccommodationProvided: false,
    hasAccommodationAllowance: false,
    accomodationTierPolicy: null,
    accomodationAllowanceInCompanyAmount: 0,
    accomodationAllowanceOutCompanyAmount: 0,
    transportationType: null,
    hasTransportationAllowance: false,
    transportationAllowanceInCompanyAmount: 0,
    transportationAllowanceOutCompanyAmount: 0,
    hasResponsibilityAllowance: false,
    responsibilityAllowanceInCompanyAmount: 0,
    responsibilityAllowanceOutCompanyAmount: 0,
    hasExtraDutyAllowance: false,
    extraDutyAllowanceInCompanyAmount: 0,
    extraDutyAllowanceOutCompanyAmount: 0,
  },
}
